import React from 'react';
import ButtonsSearch from '../../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../../components/NovoSistema/InputText';
import InputCheckBox from '../../../../../../../components/NovoSistema/InputCheckBox';
import SelectAndOptions from '../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import DoubleInput from '../../../../../../../components/NovoSistema/DoubleInput';
import Legends from '../../../../../../../components/NovoSistema/Legends';

export default function ProdutoSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <InputText title="Código" id="CodeProduto" widthPercentage="20%" />
          <InputText title="Descrição" id="DescricaoProduto" widthPercentage="40%" />
          <InputText title="Código de Barras" id="CodigoDeBarras" widthPercentage="20%" />
          <SelectAndOptions
            title="Bloqueado"
            id="Bloqueado"
            optionsArray={['Todos', 'SIM', 'NÃO']}
            widthPercentage="10%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Situacao"
            id="Situacao"
            optionsArray={['Todas', 'Ativo', 'Inativo']}
            widthPercentage="20%"
          />
          <SelectAndOptions
            title="Tipos de Produtos"
            id="tiposDeProduto"
            optionsArray={[
              '',
              'Mercadoria para revenda',
              'Matéria Prima',
              'Embalagem',
              'Produto em Processo',
              'Produto Acabado',
              'Subproduto',
              'Produto Intermediário',
              'Material de uso e consumo',
              'Ativo Imobilizado',
              'Outros Insumos',
              'Outras',
            ]}
            widthPercentage="30%"
          />
          <InputText title="NCM" id="NCM" widthPercentage="10%" />
          <InputCheckBox title="Exibir Produtos com Grade" id="ExibirProdutos" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Divisão Gerencial"
            id="DivisaoGerencial"
            optionsArray={['', 'Grupo', 'Marca', 'Fabricante', 'Familia', 'Sub Tipo', 'Linha', 'Departamento']}
            widthPercentage="20%"
          />
          <DoubleInput title="Inicial" id="Inicial" widthPercentage="35%" />
          <DoubleInput title="Final" id="Final" widthPercentage="35%" />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
      <ContainerSection>
        <h3>Legenda</h3>
        <Legends
          itens={[
            { text: 'Ativo', color: 'green' },
            { text: 'Inativo', color: 'red' },
          ]}
        />
      </ContainerSection>
    </div>
  );
}
